export var PlanType;
(function (PlanType) {
    PlanType["Domain"] = "DOMAIN";
    PlanType["Export"] = "EXPORT";
    PlanType["Paged"] = "PAGED";
    PlanType["Records"] = "RECORDS";
    PlanType["PivotBasic"] = "PIVOT_BASIC";
    PlanType["PivotDetail"] = "PIVOT_DETAIL";
})(PlanType || (PlanType = {}));
